// extracted by mini-css-extract-plugin
module.exports = {"smallSize":"DateDescBox_smallSize__23-RQ","title":"DateDescBox_title__1-3Fx","desc":"DateDescBox_desc__18zoV"};